module.exports = __webpack_public_path__ + "img/sol_white.c1b8906d.png";